import FaceBookIcon from 'svg/FaceBookIcon';
import InstagramIcon from 'svg/InstagramIcon';
import LinkedInIcon from 'svg/LinkedInIcon';
import Pencil from 'svg/Pencil';
import TikTokIcon from 'svg/TikTokIcon';
import XTwitter from 'svg/XTwitter';
import type { PlayerProfileSocialLink } from 'screens/PlayerProfile/types';
import classNames from 'styles/utils/classNames';
import EmptyAddPlaceholder from '../EmptyAddPlaceholder';
import RoundIconButton from '../RoundIconButton';

interface Props {
  links: PlayerProfileSocialLink[];
  isViewerProfile: boolean;
  onEdit?: () => void;
  className?: string;
}

const ICONS: Record<
  PlayerProfileSocialLink['key'],
  (props: { className?: string }) => JSX.Element
> = {
  instagram: InstagramIcon,
  facebook: FaceBookIcon,
  tiktok: TikTokIcon,
  linkedin: LinkedInIcon,
  x: XTwitter,
};

const LABELS: Record<PlayerProfileSocialLink['key'], string> = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  tiktok: 'TikTok',
  linkedin: 'LinkedIn',
  x: 'X',
};

export default function ProfileSocialLinks({ links, isViewerProfile, onEdit, className }: Props) {
  if (!links.length) {
    if (!isViewerProfile) return null;

    return (
      <div
        className={classNames(
          'flex items-center justify-center gap-ds-md md:justify-start',
          className,
        )}
      >
        {/* Hugs its label here, unlike the full-width block the sections use. */}
        <EmptyAddPlaceholder label="Add social media" onClick={onEdit} size="auto" />
        <RoundIconButton
          label="Edit social media"
          onClick={onEdit}
          icon={<Pencil className="h-4 w-4" />}
        />
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'flex items-center justify-center gap-ds-lg md:justify-start',
        className,
      )}
    >
      {links.map(({ key, href }) => {
        const Icon = ICONS[key];
        return (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            aria-label={LABELS[key]}
            className="text-color-text-lightmode-secondary transition-opacity hover:opacity-70 dark:text-color-text-darkmode-secondary"
          >
            <Icon className="size-5" />
          </a>
        );
      })}
      {isViewerProfile && onEdit && (
        <RoundIconButton
          label="Edit social media"
          onClick={onEdit}
          icon={<Pencil className="h-4 w-4" />}
        />
      )}
    </div>
  );
}
